module.exports = __webpack_public_path__ + "static/digitalNotification2-eb6e4d39811f88317aa678797c5afac8.png";